
import { useAddProductsFromIntegration } from './useAddProductsFromIntegration'
import type { AddProductsFromIntegrationRequest } from 'services/productIntegrationApi'

type UseProductsMutationsOptions = {
  onSuccess?: (data: any) => void
  onError?: (error: Error) => void
}

type UseProductsMutationsResult = [
  {
    uploadProducts: (payload: Omit<AddProductsFromIntegrationRequest, 'provider'>) => void
  },
  {
    data?: any
    isLoading: boolean
    isError: boolean
  }
]

export const useProductsMutations = (options?: UseProductsMutationsOptions): UseProductsMutationsResult => {
  const {
    addProductsFromIntegration,
    isLoading,
    isError,
    error,
    data,
  } = useAddProductsFromIntegration({
    onSuccess: options?.onSuccess,
    onError: options?.onError,
  })

  const uploadProducts = (payload: Omit<AddProductsFromIntegrationRequest, 'provider'>) => {
    addProductsFromIntegration({
      provider: 'shopify',
      ...payload,
    })
  }

  return [
    {
      uploadProducts,
    },
    {
      data,
      isLoading,
      isError,
    },
  ]
}
